import React from 'react';

const Label = ({ color, name }) => {
  const statusColorMap = {
    invited: '#007bff',
    active: '#28a745',
    inactive: '#6c757d',
    pending: '#ffc107',
    suspended: '#dc3545',
    'invite-accepted': '#17a2b8',
    'delete-requested': '#dc3545',
  };

  const finalColor = color || statusColorMap[name] || '#1b3f87';

  return (
    <span
      style={{
        backgroundColor: finalColor,
        color: 'white',
        padding: '2px 8px',
        borderRadius: '5px',
        fontWeight: '500',
        fontSize: '12px',
      }}>
      {name?.toUpperCase()}
    </span>
  );
};

export default Label;
